import React from 'react';

const Jobopening = () => {
  return (
    <div className="container my-5">
      {/* Filters Section */}
      <h2 className="text-center mb-4 text-primary">Filter Job Openings</h2>
      <form className="row g-3 mb-5">
        <div className="col-md-4">
          <label className="form-label">Job Category</label>
          <select className="form-select">
            <option>All Job Category</option>
            <option>Billing Software</option>
            <option>Program Manager</option>
            <option>Software Development</option>
            <option>Utility Network</option>
          </select>
        </div>
        <div className="col-md-4">
          <label className="form-label">Job Type</label>
          <select className="form-select">
            <option>All Type Job</option>
            <option>Full Time</option>
          </select>
        </div>
        <div className="col-md-4">
          <label className="form-label">Job Location</label>
          <select className="form-select">
            <option>All Job Location</option>
            <option>India</option>
            <option>USA</option>
            <option>United Kingdom</option>
          </select>
        </div>
      </form>

      {/* Job Description */}
      <div className="card shadow p-4 mb-5">
        <h3 className="text-success mb-3">Architect ESRI Utility Network</h3>
        <h5 className="mb-3">Job Description:</h5>
        <ul>
          <li>Minimum 15 years of experience in Esri’s ArcGIS suite, Utility Industry with minimum 1 UN migration experience</li>
          <li>Programming Skills: Python or SQL for scripting and Data Manipulation</li>
          <li>Knowledge of Geospatial databases: GE Smallworld, PostgreSQL with PostGIS, Oracle Spatial</li>
          <li>Strong understanding of FME workflows and utility systems (SAP, Maximo, ADMS, OMS, MDM)</li>
        </ul>
        <p><strong>Job Category:</strong> Utility Network</p>
        <p><strong>Job Type:</strong> Full Time</p>
        <p><strong>Job Location:</strong> United Kingdom, USA</p>
      </div>

      <div className="card shadow p-4 mb-5">
        <h3 className="text-success mb-3">Architect ESRI Utility Network</h3>
        <h5 className="mb-3">Job Description:</h5>
        <ul>
          <li>Minimum 15 years of experience in Esri’s ArcGIS suite, Utility Industry with minimum 1 UN migration experience</li>
          <li>Programming Skills: Python or SQL for scripting and Data Manipulation</li>
          <li>Knowledge of Geospatial databases: GE Smallworld, PostgreSQL with PostGIS, Oracle Spatial</li>
          <li>Strong understanding of FME workflows and utility systems (SAP, Maximo, ADMS, OMS, MDM)</li>
        </ul>
        <p><strong>Job Category:</strong> Utility Network</p>
        <p><strong>Job Type:</strong> Full Time</p>
        <p><strong>Job Location:</strong> United Kingdom, USA</p>
      </div>


      {/* Apply Now Form */}
      <div className="card p-4 shadow">
        <h4 className="text-center text-primary mb-4">Apply for this Position</h4>
        <form>
          <div className="mb-3">
            <label className="form-label">Full Name</label>
            <input type="text" className="form-control" required />
          </div>
          <div className="mb-3">
            <label className="form-label">Email</label>
            <input type="email" className="form-control" required />
          </div>
          <div className="mb-3">
            <label className="form-label">Phone</label>
            <input type="tel" className="form-control" required />
          </div>
          <div className="mb-3">
            <label className="form-label">Upload CV/Resume</label>
            <input type="file" className="form-control" required />
          </div>
          <div className="d-grid">
            <button type="submit" className="btn btn-primary">Submit Application</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Jobopening;
